import { FormikProps } from 'formik'
import { updateDays } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { INewEditModalFormValues } from '../../new-edit-modal.form'

export const handleBreakChange = (selected: any, formik: FormikProps<INewEditModalFormValues>) => {
  const { setFieldValue, values } = formik

  setFieldValue('break', selected.value)

  const days = updateDays(values.days, {
    break: selected.value,
  })

  setFieldValue('days', days)
}
